/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface CancelEncounterRequest
 */
export interface CancelEncounterRequest {
    /**
     * A cancelled code from episode_of_care_status_reasons
     */
    status_reason: string;
    /**
     * When the booking was cancelled. Defaults to now.
     */
    effective_at?: Date;
    /**
     * 
     */
    comment?: string;
    /**
     * 409 if the episode changed since
     */
    expected_latest_history_id?: string;
}

/**
 * Check if a given object implements the CancelEncounterRequest interface.
 */
export function instanceOfCancelEncounterRequest(value: object): value is CancelEncounterRequest {
    if (!('status_reason' in value) || value['status_reason'] === undefined) return false;
    return true;
}

export function CancelEncounterRequestFromJSON(json: any): CancelEncounterRequest {
    return CancelEncounterRequestFromJSONTyped(json, false);
}

export function CancelEncounterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelEncounterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status_reason': json['status_reason'],
        'effective_at': json['effective_at'] == null ? undefined : (parseDateTime(json['effective_at'])),
        'comment': json['comment'] == null ? undefined : json['comment'],
        'expected_latest_history_id': json['expected_latest_history_id'] == null ? undefined : json['expected_latest_history_id'],
    };
}

export function CancelEncounterRequestToJSON(json: any): CancelEncounterRequest {
    return CancelEncounterRequestToJSONTyped(json, false);
}

export function CancelEncounterRequestToJSONTyped(value?: CancelEncounterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_reason': value['status_reason'],
        'effective_at': value['effective_at'] == null ? value['effective_at'] : serializeDateTime(value['effective_at']),
        'comment': value['comment'],
        'expected_latest_history_id': value['expected_latest_history_id'],
    };
}

